// extracted by mini-css-extract-plugin
export default {"createProjectButton":"CreateProjectMenuButton-module__createProjectButton__8bO0E","createProjectIcon":"CreateProjectMenuButton-module__createProjectIcon__Mq5YF"};